import React, { Component } from 'react';
import { withRouter, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";

import AffiliateMainBanner from "./AffiliateLandingPage/AffiliateMainBanner";

// import { PageNotFound } from './PageNotFound';
import CollectionDetailPage from './CollectionDetailPage';
import { ROOT_API_PATH } from "./actions/constant";
import './css/App.css';

class App extends Component {
  render() {

    if(this.props.pagenotfound){
      window.location.href = ROOT_API_PATH+"error.php";
    }
    return (
      <Switch>
        <Route exact path={`/:username`} component={AffiliateMainBanner}/>
        <Route exact path={`/:username/:collection`} component={CollectionDetailPage}/>
      </Switch>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
      activities: state.activities,
      filters: state.filters,
      contentLoading: state.contentLoading,
      pageLoading: state.pageLoading,
      currentCollection: state.collections.current,
      fromAffiliate: state.collections.fromAffiliate,
      filterdActivity: state.filters.activities,
      affiliateLogo: state.affiliateLogo,
      affiliateUsername: state.affiliateUsername,
      pagenotfound: state.pageNotFound,
      affiliateName: state.affiliateName
  };
};
export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js